import { render, staticRenderFns } from "./ProjectConfigStatus.vue?vue&type=template&id=c8a4e740"
import script from "./ProjectConfigStatus.vue?vue&type=script&lang=js"
export * from "./ProjectConfigStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports